<template>
  <div>
    <h3>
      V.0.0
    </h3>
  </div>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({})
};
</script>
